import { InputAdornment, TextField, Tooltip } from "@mui/material";

import { IField } from "./Field";
import { Info } from "@mui/icons-material";

const InputField: React.FC<IField> = ({
  form,
  name,
  label,
  type,
  disabled,
  inputOptions,
  error,
  errorMessage,
  defaultValue,
  tooltip,
  maxLength,
  pattern,
}) => {
  return (
    <TextField
      key={"field-" + name}
      fullWidth
      label={inputOptions?.required ? label + " *" : label}
      type={type}
      {...form.register(name, {
        ...inputOptions,
      })}
      error={error}
      helperText={errorMessage}
      defaultValue={defaultValue}
      disabled={disabled}
      inputProps={{
        maxLength: maxLength,
        pattern: pattern,
      }}
      InputProps={
        tooltip
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={tooltip}>
                    <Info sx={{ cursor: "pointer" }} />
                  </Tooltip>
                </InputAdornment>
              ),
            }
          : {}
      }
    />
  );
};

export default InputField;
